import * as Sentry from '@sentry/react';
import i18next from 'i18next';
import { AppSettingsData } from '@types';
import { exposedApi } from '@expose';
import { oni18nextInitialized, validateCustomVariables } from '@utils';

function setupSentryScope({ user_id }: AppSettingsData) {
    oni18nextInitialized(() => Sentry.setUser({ language: i18next.language }));

    i18next.on('languageChanged', (language: string) => {
        Sentry.setUser({ id: user_id, language });
    });
}

function setCustomLocale(customLocale: string) {
    const changeLanguage = () => {
        // if the language changed after setting the custom locale, here it will overwrite the previous selection,
        // so if the company has a custom locale, we hide the dropdown with the language
        if (i18next.language !== customLocale) {
            i18next.changeLanguage(customLocale);
        }
    };

    oni18nextInitialized(changeLanguage);
}

export function setupApp(data: AppSettingsData) {
    const content = data.widget_content_customization;
    if (content && Object.keys(content).length) {
        content.variables && content.variables && validateCustomVariables(content.variables);
    }

    // call it here as the company is guaranteed to exist
    exposedApi.listen();

    setupSentryScope(data);

    if (data.custom_locale) {
        setCustomLocale(data.custom_locale);
    }
}
